<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">

    <div class="divider" v-if="variation.attributes"><span>Atributos</span></div>

    <div class="l-row">
      <form-group v-for="(label, attribute) in variation.attributes" :key="attribute" v-if="variation.attributes" :label="$t(attribute).label" :columns="3" :error="getError('attributes.' + attribute, variation.sku)">
        <input v-model="variation.attributes[attribute]" class="form-select" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="variation.crossDocking" :label="$t('crossDocking.label')" :columns="3" :error="getError('crossDocking', variation.sku)" :required="true">
        <input v-model="variation.crossDocking" class="form-select" :disabled="disabledInputs()" type="number">
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?3fa1c53e